import { getData, getScanDate } from '@/components/report/service';
import ActualDetail from '@/Entity/ActualDetail';
import { SuperiorityProduct } from '@/Entity/PublicEntity';
import RouteEntity from '@/Entity/RouteEntity';
import GenerateCondit, { Bound } from '@/models/GenerateCondit';
import { CALCWEIGHT, getToDay } from '@/models/GenerateCondit/Interrelated';
import { crudRequest } from '@/services/api';
import { signOfflineBatch } from '@/services/waybillCashRate';
import moment, { utc } from 'moment';
import { message } from 'antd';

const today = new Date();

const params = {
  waybillNo: '',
  originProvince: '',
  countyAgingOriginCenter: '',
  isProduct: [], //[SuperiorityProduct.YES, SuperiorityProduct.NO],
  startDate: moment(today).add(-1, 'days').format('YYYY-MM-DD 00:00:00'),
  destinationProvinceArea: '',
  countyAgingDestinationCenter: '',
  productType: '',
};

const actualTable = 'static_actual_time_consume_result'; // 实际表
const preTable = 'static_actual_time_consume_result_sat';

export default {
  namespace: 'waybillcashrate',
  state: {
    searchParams: { ...params },
    dataList: [],
    dataSql: '',
    page: 1,
    pageSize: 20,
    scheduleImportVo: [],
    // importLoding: false,
  },

  effects: {
    *getData({ payload }, { put, call, select }) {
      crudRequest('/api/route/waybillCashRate/search');
      const waybillcashrate = yield select(({ waybillcashrate }) => waybillcashrate);
      const { searchParams, page, pageSize } = waybillcashrate;
      let { dataList } = waybillcashrate;
      const {
        startDate,
        waybillNo,
        originProvince,
        countyAgingOriginCenter,
        isProduct,
        destinationProvinceArea,
        countyAgingDestinationCenter,
        productType,
      } = searchParams;
      const dataSource = window.location.port === '16881' ? preTable : actualTable;
      const pages = payload?.page ?? page;
      const offset = pageSize * (pages - 1) || null;
      const gc = new GenerateCondit<ActualDetail>({
        dataSource,
        dimensions: [
          'waybillNo',
          'onTime',
          'productType',
          'superiorityProduct',
          'areaType',
          'calcWeight',
          'originSite',
          'countyAgingOriginCenter',
          'originRegion',
          'originProvinceArea',
          'destinationSite',
          'countyAgingDestinationCenter',
          'destinationRegion',
          'destinationProvinceArea',
          'sendDate',
          '__time',
          'countyAgingAllAging',
          'actualPeriod',
          'delayPeriod',
          'originCounty',
          'destinationCounty',
        ],
        aggregators: [CALCWEIGHT],
        startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
        endDate: moment(startDate).format('YYYY-MM-DD 23:59:59'),
        queryType: 'scan',
        offset,
        limit: pageSize,
      });

      const entity = new ActualDetail({
        waybillNo,
        originProvinceAreaCode: originProvince?.code,
        countyAgingOriginCenterCode: countyAgingOriginCenter?.code,
        superiorityProduct: isProduct,
        destinationProvinceAreaCode: destinationProvinceArea?.code,
        countyAgingDestinationCenterCode: countyAgingDestinationCenter?.code,
        productType: productType,
      });
      const condit = gc.converCondit(entity);
      const data = yield getScanDate(condit);
      const tempData = data?.map((m, index) => ({
        key: index + offset,
        ...m,
        signDate: moment(m.__time).utc().format('YYYY-MM-DD HH:mm:ss'),
      }));
      if (pages == 1) dataList = [];
      Array.prototype.push.apply(dataList, tempData);
      yield put({
        type: 'updateState',
        payload: { dataList: [...dataList], dataSql: condit.toSQL(), page: pages },
      });
    },

    *exportData({ payload }, { put, call, select }) {
      crudRequest('/api/route/waybillCashRate/search');
      const waybillcashrate = yield select(({ waybillcashrate }) => waybillcashrate);
      const { searchParams, page, pageSize } = waybillcashrate;
      let { dataList } = waybillcashrate;
      const {
        startDate,
        waybillNo,
        originProvince,
        countyAgingOriginCenter,
        isProduct,
        destinationProvinceArea,
        countyAgingDestinationCenter,
        productType,
      } = searchParams;
      const dataSource = window.location.port === '16881' ? preTable : actualTable;
      const pages = payload?.page ?? page;
      const offset = pageSize * (pages - 1) || null;
      const gc = new GenerateCondit<ActualDetail>({
        dataSource,
        dimensions: [
          'waybillNo',
          'onTime',
          'productType',
          'superiorityProduct',
          'areaType',
          'calcWeight',
          'originSite',
          'countyAgingOriginCenter',
          'originRegion',
          'originProvinceArea',
          'destinationSite',
          'countyAgingDestinationCenter',
          'destinationRegion',
          'destinationProvinceArea',
          'sendDate',
          '__time',
          'countyAgingAllAging',
          'actualPeriod',
          'delayPeriod',
          'originCounty',
          'destinationCounty',
        ],
        aggregators: [CALCWEIGHT],
        startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
        endDate: moment(startDate).format('YYYY-MM-DD 23:59:59'),
        queryType: 'scan',
        offset,
        limit: pageSize,
      });

      const entity = new ActualDetail({
        waybillNo,
        originProvinceAreaCode: originProvince?.code,
        countyAgingOriginCenterCode: countyAgingOriginCenter?.code,
        superiorityProduct: isProduct,
        destinationProvinceAreaCode: destinationProvinceArea?.code,
        countyAgingDestinationCenterCode: countyAgingDestinationCenter?.code,
        productType: productType,
      });
      const condit = gc.converCondit(entity);
      const data = yield getScanDate(condit);
      const tempData = data?.map((m, index) => ({
        key: index + offset,
        ...m,
        signDate: moment(m.__time).utc().format('YYYY-MM-DD HH:mm:ss'),
      }));
      if (pages == 1) dataList = [];
      Array.prototype.push.apply(dataList, tempData);
      yield put({
        type: 'updateState',
        payload: { dataList: [...dataList], dataSql: condit.toSQL(), page: pages },
      });

      if (dataList.length > 0) {
        yield put({
          type: 'filedownload/waybillCashRateExport',
          payload: {
            endDate: moment(searchParams.startDate).add(1, 'days').format('YYYY-MM-DD 00:00:00'),
            startDate: moment(searchParams.startDate).format('YYYY-MM-DD 00:00:00'),
          },
        });
      } else {
        message.warning('没有可以导出的数据');
      }
    },

    // 导入
    *signOfflineBatch({ callBack }, { select, call }) {
      const { scheduleImportVo } = yield select(({ waybillcashrate }) => waybillcashrate);
      if (!scheduleImportVo?.length) return message.error('导入文件数据为空');
      const result = yield call(signOfflineBatch, { staticSignOfflineImportVos: scheduleImportVo });
      // console.log(result)
      if (result?.code === 1) {
        // message.success( result.message || '导入成功！')
        callBack && callBack(result);
      } else {
        message.error('导入文件出现异常,服务端没有响应!');
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
